export default {
      id: "icon-title-usage",
      viewBox: "0 0 96 21",
      url: "../icon/" + "icons.svg#icon-title-usage",
      toString: function () {
        return this.url;
      }
    }